
import React, { useState } from 'react';






import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
    Row,
  } from "reactstrap";


import question from '../../assets/img/question.svg'





const IncludeHelpModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;
  
  const [modal, setModal] = useState(false);
  

  const toggle = () => setModal(!modal);
  console.log(props.deviat)
  return (
    <div>
       <img alt="" onClick={toggle} src={question}  className="icons" style={{height:"15px",width:'15px',cursor:'pointer'}}/>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Include/Exclude activities</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">
            <Row style={{padding:'10px'}}>     
                <p>By default all activities count on your fitness estimation. There are times were a single or multiple activities create not representative data. In this case it is adviced to exclude these activities from fitness estimation.</p>
              <p>Excluded activities <span class="text-warning"> still count on your weekly/monthly mileage,fatigue/training load estimation and running program progress.</span> The app just ignores this values when the Running Index,VO2max, and training paces are calculated</p>
              <p>When to exclude an activity?</p>
              <ul>
                <li>Faulty Heart rate data</li>
                <li>Running activities that contain to much walking in between</li>
                <li>Sessions shorter than 15 minutes</li>
                <li>Extremely hilly terrain</li>
                <li>For any other reason you think an activity is not representative of your fitness</li>
              </ul>
               
            </Row>
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button color="danger" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

function feedbackMessage(deviation){
    var message = "Need more Data. Train more and come back later for feedback"
    if (deviation<=0.1){
        message = 'Need more Data. Train more and come back later for feedback'
        return [message,'text-warning']
      }
    if (deviation<=1){
      message = 'Excellent work your training habits are very consistent.'
      return [message,'text-success']
    }
    if (deviation<=3){
        message = 'Your training habits consistent.'
        return [message,'text-info']
    }
    if (deviation<=5){
        message = 'Your training habits are not consistent. Consider following a more structured program. Injury risk is moderate'
        return [message,'text-warning']
    }
    if (deviation<=10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is high'
        return [message,'text-danger']
    }
    if (deviation>10){
        message = 'Unstructured training program.Your day to day training habits are extremely inconsistent. Injury risk is critical high'
        return [message,'text-danger']
    }
    return [message,'text-warning']
}
export default IncludeHelpModal;